import React from "react";
import Home from "./pages/Home";

const IndexHome = () => {
  return (
    <div style={{ background: "#0f0922" }}>
      <Home />
    </div>
  );
};

export default IndexHome;
